import { ChatMessageContact, ChatMessageContactPhone } from '@src/types';
import { useState } from 'react';
import useContactExists from '../hooks/useContactExists';
import ChatMessageContactDownload from './ChatMessageContactDownload';
import ChatMessageContactRedirect from './ChatMessageContactRedirect';
import ChatMessageContactSave from './ChatMessageContactSave';

export type ChatMessageContactActionsProps = {
  contact: ChatMessageContact;
  activePhone?: ChatMessageContactPhone;
};

const ChatMessageContactActions: React.FC<ChatMessageContactActionsProps> = ({
  contact,
  activePhone,
}) => {
  const [isContactSaved, setIsContactSaved] = useState(false);
  const { isContactExists, isCompletedContactRequest } = useContactExists(
    activePhone?.phone || ''
  );

  return (
    <div style={{ display: 'flex', width: 'inherit' }}>
      <ChatMessageContactDownload contact={contact} />
      {isCompletedContactRequest &&
        (isContactExists || isContactSaved ? (
          <ChatMessageContactRedirect
            phoneNumber={activePhone?.wa_id || activePhone?.phone || ''}
          />
        ) : (
          <ChatMessageContactSave
            contact={contact}
            activePhone={activePhone as ChatMessageContactPhone}
            onContactSave={() => setIsContactSaved(true)}
          />
        ))}
    </div>
  );
};

export default ChatMessageContactActions;
